import { 
    Box, 
   // Typography 
} from "@mui/material";
import banner from "../assets/images/Template.jpg";

export default function Templates () {
    return(
        <Box sx={{ width: '100%', height: '100%', bgcolor: 'background.default' }}>
            <Box component="img" src={banner} alt="Templates" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            {/* <Box sx={{ p: 3 }}>
                <Typography variant="h5" fontWeight={800} color="text.primary">Templates</Typography>
                <Typography variant="body2" color="text.secondary">Coming soon...</Typography>
            </Box> */}
        </Box>
    );
}